/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";

export interface BookInsuranceRequest {
  shipmentId: string;
}

export interface CancelInsuranceRequest {
  shipmentId: string;
  reason: string;
}

export interface RegenerateInsuranceCertificateRequest {
  shipmentId: string;
}

export interface SetInsuranceCertificateNumberRequest {
  shipmentId: string;
  certificateNumber: string;
}

export interface ViewInsuranceCertificateDetailsRequest {
  shipmentId: string;
}

/**
 *
 */
export class ShipmentInsuranceApi extends runtime.BaseAPI {
  /**
   */
  async bookInsuranceRaw(
    requestParameters: BookInsuranceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling bookInsurance().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/insurance/book`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bookInsurance(
    requestParameters: BookInsuranceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.bookInsuranceRaw(requestParameters, initOverrides);
  }

  /**
   */
  async cancelInsuranceRaw(
    requestParameters: CancelInsuranceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling cancelInsurance().',
      );
    }

    if (requestParameters["reason"] == null) {
      throw new runtime.RequiredError(
        "reason",
        'Required parameter "reason" was null or undefined when calling cancelInsurance().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/insurance/cancel`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async cancelInsurance(
    requestParameters: CancelInsuranceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.cancelInsuranceRaw(requestParameters, initOverrides);
  }

  /**
   */
  async regenerateInsuranceCertificateRaw(
    requestParameters: RegenerateInsuranceCertificateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling regenerateInsuranceCertificate().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/insurance/regenerate-certificate-pdf`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async regenerateInsuranceCertificate(
    requestParameters: RegenerateInsuranceCertificateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.regenerateInsuranceCertificateRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setInsuranceCertificateNumberRaw(
    requestParameters: SetInsuranceCertificateNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling setInsuranceCertificateNumber().',
      );
    }

    if (requestParameters["certificateNumber"] == null) {
      throw new runtime.RequiredError(
        "certificateNumber",
        'Required parameter "certificateNumber" was null or undefined when calling setInsuranceCertificateNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["certificateNumber"] != null) {
      queryParameters["certificateNumber"] =
        requestParameters["certificateNumber"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/insurance/set-certificate-number`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setInsuranceCertificateNumber(
    requestParameters: SetInsuranceCertificateNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setInsuranceCertificateNumberRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async viewInsuranceCertificateDetailsRaw(
    requestParameters: ViewInsuranceCertificateDetailsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling viewInsuranceCertificateDetails().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/insurance/view-details`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async viewInsuranceCertificateDetails(
    requestParameters: ViewInsuranceCertificateDetailsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.viewInsuranceCertificateDetailsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
